import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '@app/shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { LearnerHomeDiscoverComponent } from '@app/learner-home/components/learner-home-discover/learner-home-discover.component';
import { ProfileAssignmentsComponent } from '@app/profile/components/profile-assignments/profile-assignments.component';
import { ProfileAssignmentsComponent2 } from '@app/profile/components/profile-assignments/profile-assignments.component2';
import { ProfilePathwaysComponent } from '@app/profile/components/profile-pathways/profile-pathways.component';
import { ProfileSharedComponent } from '@app/profile/components/profile-shared/profile-shared.component';
import { ProfileGroupsComponent } from '@app/profile/components/profile-groups/profile-groups.component';
import { ProfilePlansComponent } from '@app/profile/components/profile-plans/profile-plans.component';
import { ProfileSavedComponent } from '@app/profile/components/profile-saved/profile-saved.component';
import { LearnerHomeTrackerService } from '@app/learner-home/services/learner-home-tracker.service';
import { ProfileSkillStandardsComponent } from '@app/profile/components/profile-skill-standards/profile-skill-standards.component';
import { WindowLayoutService } from '@app/shared/services/window-layout/window-layout.service';
import { GlobalNavigationService } from '@app/shared/services/global-navigation.service';
import { LDFlagsService } from '@dg/shared-services';

@Component({
  selector: 'dgx-learner-home',
  templateUrl: './learner-home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearnerHomeComponent {
  public showSidebar = true;
  public skipLinkText = this.translateService.instant('dgSkipNav_SkipSidebar');
  public showLearningBudget = false;

  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    private windowLayoutService: WindowLayoutService,
    private learnerHomeTrackerService: LearnerHomeTrackerService,
    private globalNavigationService: GlobalNavigationService,
    private ldFlagService: LDFlagsService
  ) {
    this.learnerHomeTrackerService.setTrackerLocationLearnerHome();
  }

  public get rowLength() {
    return this.windowLayoutService.isMsTeams ? 4 : 3;
  }

  public ngOnInit() {
    this.globalNavigationService.register({
      title: this.translateService.instant('AppHeader_HomeTitle'),
    });
    this.showLearningBudget = this.ldFlagService.isPaidCMUser;
  }

  public ngOnDestroy(): void {
    this.globalNavigationService.reset();
  }

  public onActivate(component: any) {
    const profile = this.authService.authUser.viewerProfile;
    switch (component.CLASS_NAME) {
      case 'LearnerHomeDiscover':
        component = component as LearnerHomeDiscoverComponent;
        component.rowLength = this.rowLength;
        break;
      case 'ProfileAssignmentsComponent':
        component = component as ProfileAssignmentsComponent;
        component.rowLength = this.rowLength;
        break;
      case 'ProfileAssignmentsComponent2':
        component = component as ProfileAssignmentsComponent2;
        component.rowLength = this.rowLength;
        break;
      case 'ProfileSharedComponent':
        component = component as ProfileSharedComponent;
        component.rowLength = this.rowLength;
        break;
      case 'ProfilePlansComponent':
        component = component as ProfilePlansComponent;
        component.owner = {
          id: profile.userProfileKey,
          name: profile.name,
          isEngaged: profile.isEngaged,
        };
        component.rowLength = this.rowLength;
        component.showHeader = true;
        break;
      case 'ProfileSavedComponent':
        component = component as ProfileSavedComponent;
        component.rowLength = this.rowLength;
        break;
      case 'ProfileGroupsComponent':
        component = component as ProfileGroupsComponent;
        component.owner = {
          id: profile.userProfileKey,
          isEngaged: profile.isEngaged,
        };
        break;
      case 'ProfilePathwaysComponent':
        component = component as ProfilePathwaysComponent;
        component.rowLength = this.rowLength;
        component.owner = {
          id: profile.userProfileKey,
          name: profile.name,
          isEngaged: profile.isEngaged,
        };
        component.showHeader = true;
        break;
      case 'ProfileSkillStandardsComponent':
        component = component as ProfileSkillStandardsComponent;
        component.rowLength = this.rowLength;
        break;
      default:
        break;
    }
  }
}
